import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailBrandsProps as Props } from './types';
import { getCompanyBrands } from '../../../services/companies';

export const Component: FunctionComponent<Props> = (props) => {
  const [brandIds, setBrandIds] = useState<number[]>([]);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await getCompanyBrands(props.company.id);
        const ids: number[] = response.brandIds ?? [];
        setBrandIds(ids);
        props.setIdCount('brandIds', ids.length);
      } catch (error) {
        console.log(error);
      }
    };
    fetchBrands();
  }, [props.company.id, props.setIdCount]);

  return (
    <Presentation
      brandIds={brandIds}
      coverNoImg={props.coverNoImg}
      dataCategory={props.dataCategory}
      dataValue={props.dataValue}
    />
  );
};
